import React from 'react';
import { Mail, Phone, Youtube, Instagram, Facebook, Linkedin } from 'lucide-react';
const LOGO_URL = 'https://www.apc360zone.com/uploaded%2Fimages%2FRedesigne%202024%2FMTDLarge%201.png';
export function Footer() {
  return <footer className="bg-brand-gray-900 border-t border-brand-gray-800 pt-16 pb-8" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-3">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-4">
            <a href="/" className="inline-block mb-6" data-id="element-5">
              <img src={LOGO_URL} alt="Medina Tactical Dynamics" className="h-16 w-auto" data-id="element-6" />
            </a>
            <p className="text-brand-gray-400 max-w-md mb-6" data-id="element-7">
              Committed to providing our clients with highest quality of service
              combined with a strong sense of 360° situational awareness.
            </p>
            <div className="flex space-x-4" data-id="element-8">
              <a href="https://www.youtube.com/channel/UCWe8nIgfZn-Lhny4k-Wn3Wg" target="_blank" rel="noreferrer" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-9">
                <Youtube className="w-5 h-5" data-id="element-10" />
              </a>
              <a href="https://www.instagram.com/medinatactical360/" target="_blank" rel="noreferrer" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-11">
                <Instagram className="w-5 h-5" data-id="element-12" />
              </a>
              <a href="https://www.facebook.com/TeamAPCUSA/" target="_blank" rel="noreferrer" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-13">
                <Facebook className="w-5 h-5" data-id="element-14" />
              </a>
              <a href="https://www.linkedin.com/in/jose-medina-a84845a/" target="_blank" rel="noreferrer" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-15">
                <Linkedin className="w-5 h-5" data-id="element-16" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-17">
            <h3 className="text-sm font-bold text-brand-white uppercase tracking-widest mb-6" data-id="element-18">
              Navigation
            </h3>
            <ul className="space-y-3" data-id="element-19">
              <li data-id="element-20">
                <a href="/about-apc" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-21">
                  About Us
                </a>
              </li>
              <li data-id="element-22">
                <a href="/meet-the-founder" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-23">
                  Meet the Founder
                </a>
              </li>
              <li data-id="element-24">
                <a href="/training" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-25">
                  Training Calendar
                </a>
              </li>
              <li data-id="element-26">
                <a href="/blog" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-27">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-28">
            <h3 className="text-sm font-bold text-brand-white uppercase tracking-widest mb-6" data-id="element-29">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-30">
              <li data-id="element-31">
                <a href="tel:18666343373" className="flex items-center gap-3 text-brand-gray-400 hover:text-brand-teal transition-colors text-sm group" data-id="element-32">
                  <Phone className="w-4 h-4 text-brand-gray-600 group-hover:text-brand-teal" data-id="element-33" />
                  1-866-634-3373
                </a>
              </li>
              <li data-id="element-34">
                <a href="mailto:info@apc360zone.com" className="flex items-center gap-3 text-brand-gray-400 hover:text-brand-teal transition-colors text-sm group" data-id="element-35">
                  <Mail className="w-4 h-4 text-brand-gray-600 group-hover:text-brand-teal" data-id="element-36" />
                  info@apc360zone.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-37">
          <p className="text-brand-gray-500 text-xs" data-id="element-38">
            &copy; {new Date().getFullYear()} Medina Tactical Dynamics. All
            rights reserved.
          </p>
          <div className="flex gap-4 text-xs text-brand-gray-500" data-id="element-39">
            <span data-id="element-40">[Placeholder: Legal/Privacy Links]</span>
          </div>
        </div>
      </div>
    </footer>;
}